/**
 * True when pathname is a tenant-scoped recovery route (`/:tenantCode/recovery...`).
 */
export function isCustomerRecoveryPath(pathname: string): boolean {
  return /\/[^/]+\/recovery(?:\/|$)/.test(pathname);
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * True when pathname is already on `…/recovery/{slug}` (optional trailing slash).
 * Used by L1 fallback and useCustomerErrorHandler to avoid re-assign loops.
 */
export function isOnRecoverySlug(pathname: string, slug: string): boolean {
  if (!isCustomerRecoveryPath(pathname)) {
    return false;
  }
  return new RegExp(`/recovery/${escapeRegExp(slug)}/?$`).test(pathname);
}
